import { render, staticRenderFns } from "./AppOverAllAssessmentListingFilterHeader.vue?vue&type=template&id=4507ccdc&scoped=true"
import script from "./AppOverAllAssessmentListingFilterHeader.vue?vue&type=script&lang=ts"
export * from "./AppOverAllAssessmentListingFilterHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4507ccdc",
  null
  
)

export default component.exports